// extracted by mini-css-extract-plugin
module.exports = {"Header":"styles-module--Header--ChGjM","Header__logo":"styles-module--Header__logo--1d9HF","Header__logoImg":"styles-module--Header__logoImg--1xHV3"};